<canvas
  class="c-tree-map__canvas"
  #canvas
  (click)="_onClick($event)"
  (dblclick)="_onDblClick($event)"
  (mouseenter)="_onMouseEnter($event)"
  (mouseleave)="_onMouseLeave($event)"
></canvas>
